<template>
    <div class="architecture">
        <div class="title">平台架构图</div>
        <div class="bg-img"></div>
    </div>
</template>
<script>
export default {
    name:'Architecture'
}
</script>
<style  scoped>
.architecture {
    margin-top: 50px;
    background-color: #eceef3;
    padding-bottom: 50px;
}
.title {
    font-size: 28px;
    color: #212224;
    letter-spacing: 0;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 50px;
}
.bg-img {
    width: 1180px;
    height: 670px;
    margin: 0 auto;
    background: url(@/assets/images/images/architecture.png) no-repeat;

}
</style>